/*
 * サブシステム名：
 * 定型コース登録(package版)
 * 表示項目カスタマイズ(滋賀自工)
 */
import D2MSTD0460 from '@/views/MST/D2MSTD0460.js'

export default {
  extends: D2MSTD0460,
  name: 'MstTeikeiCorceEditCustomForSGJ',
  data: () => ({
  }),
  computed: {
  },
  methods: {
  }
}
